import React from "react";
import about from "../image/about.png";

const About = () => {
  return (
    <div className="bg-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* About Us Section */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">About Us</h1>
        <p className="text-gray-600 mb-8">Find details about who we are and our team.</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Image Section */}
          <div>
            <img
              src={about} // Replace with the actual image URL
              alt="About Us"
              className="rounded-md shadow-md"
            />
          </div>

          {/* About Text Section */}
          <div>
            <p className="text-gray-700 mb-4">
              <span className="font-bold text-gray-900">Sanjay K Nathani & Co.</span> is a professionally managed Chartered Accountancy firm providing one-stop solutions for{" "}
              <span className="font-semibold">Statutory Audit, Tax Audit, GST Audit, Direct Tax Compliance, Indirect Tax Compliance, Accounting Services, Business Management Consultancy, and Various Registration Services</span>.
            </p>
            <p className="text-gray-700 mb-4">
              We were established in 2012, and we are a dedicated team of chartered accountants committed to providing comprehensive financial solutions. With over a decade of experience, we have built a reputation for delivering accurate, reliable, and insightful services to a diverse range of clients.
            </p>
            <p className="text-gray-700">
              We pride ourselves on our client-centric approach, understanding that each business has unique needs. Our focus is on building long-term relationships based on trust, integrity, and a deep understanding of our clients' financial goals. We strive to provide our clients with the financial clarity and confidence they need to succeed in today's dynamic business environment.
            </p>
          </div>
        </div>

        {/* Vision Section */}
        <div className="mt-12 bg-[#005A8C] text-white p-6 rounded-md shadow-md">
          <h2 className="text-xl font-bold mb-4">Our Vision</h2>
          <p>
            To be recognized as a leading chartered accountancy firm, renowned for its unwavering commitment to client success, professional excellence, and ethical practice. We aspire to be the trusted advisors of choice, empowering businesses to achieve their full potential through sound financial guidance and innovative solutions.
          </p>
        </div>

        {/* Mission Section */}
        <div className="mt-8 bg-[#005A8C] text-white p-6 rounded-md shadow-md">
          <h2 className="text-xl font-bold mb-4">Our Mission</h2>
          <p>
            To provide exceptional financial services that add value to our clients' businesses. We are dedicated to delivering accurate, timely, and insightful solutions while upholding the highest standards of professional integrity and ethical conduct. We strive to build strong, collaborative relationships with our clients, understanding their unique needs and providing tailored support to achieve their financial objectives. We are committed to continuous professional development, ensuring our team remains at the forefront of industry best practices and regulatory changes.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About;
